import React from 'react';
import { PageHero } from '../components/shared/PageHero';
import { AERSystem } from '../components/technology/AERSystem';
import { HPBBattery } from '../components/technology/HPBBattery';
import { UnlockAndGo } from '../components/technology/UnlockAndGo';
import { NewApp } from '../components/technology/NewApp';
import { TechnologyCTA } from '../components/technology/TechnologyCTA';
import { useSEO } from '../hooks/useSEO';

export default function Technology() {
  useSEO({
    title: 'Innovación y Tecnología',
    description: 'Descubre nuestras tecnologías: Baterías HPB, Sistema de recuperación AER, App Inteligente y Desbloqueo NFC.',
    keywords: 'tecnología patinetes, batería hpb, kers, nfc scooter, app zwheel'
  });

  return (
    <div className="bg-white">
      {/* 4.0: Hero */}
      <PageHero
        tag="Tecnología ZWheel"
        title="Innovación que te mueve"
        subtitle="Descubre las tecnologías patentadas que hacen de ZWheel una experiencia única."
      />

      {/* 4.1: AER System */}
      <AERSystem />

      {/* 4.2: HPB Battery */}
      <HPBBattery />

      {/* 4.3: Unlock & Go */}
      <UnlockAndGo />

      {/* 4.4: New App */}
      <NewApp />

      {/* CTA */}
      <TechnologyCTA />
    </div>
  );
}
